import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'roles';

export interface State extends Status {
    data: string[];
}

export const initialState: State = {
    data: [],
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,
    on(actions.reloadGraphRoles, (state) => ({ ...state, loaded: false })),
    on(actions.loadGraphRolesSuccess, (state, { data }) => ({ ...state, data, loaded: true, error: false })),
    on(actions.loadGraphRolesFailure, (state, { error }) => ({ ...state, error, loaded: true })),
);
